import { Action } from '@ngrx/store';
import {User} from '../../shared/models/user.model';

export const LOGIN_START = '[Auth] Login Start';
export const LOGIN = '[Auth] Login';  // Login Success
export const LOGOUT = '[Auth] Logout';


export class Login implements Action {
  readonly type = LOGIN;
  constructor(
    public payload: {
      uid: string,
      username: string,
      email: string,
      role: string,
      refresh_token: string,
      access_token: string,
      id_token: string,
      _tokenExpirationDate: Date,
      exp: number
    }
  ) {}
}

export class Logout implements Action {
  readonly type = LOGOUT;
}

export class LoginStart implements Action {
  readonly type = LOGIN_START;
  constructor(public payload: {email: string, password: string}) {}
}

export type AuthActions = Login | Logout;
